import { ConfigProvider } from 'antd'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import ar_EG from 'antd/locale/ar_EG'
import { useState } from 'react'
import Login from './pages/Login'
import AdminLogin from './pages/AdminLogin'
import Dashboard from './pages/Dashboard'
import AdminDashboard from './pages/AdminDashboard'

function App() {
  const [user, setUser] = useState(
    localStorage.getItem('token')
      ? JSON.parse(localStorage.getItem('user'))
      : null
  )

  const [admin, setAdmin] = useState(
    localStorage.getItem('adminToken')
      ? JSON.parse(localStorage.getItem('admin'))
      : null
  )

  const handleLogout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    setUser(null)
  }

  const handleAdminLogout = () => {
    localStorage.removeItem('adminToken')
    localStorage.removeItem('admin')
    setAdmin(null)
  }

  return (
    <ConfigProvider
      locale={ar_EG}
      direction="rtl"
      theme={{ token: { colorPrimary: '#1890ff' } }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={
            user ? <Navigate to="/" /> : <Login onLogin={setUser} />
          } />
          <Route path="/admin/login" element={
            admin ? <Navigate to="/admin" /> : <AdminLogin onLogin={setAdmin} />
          } />
          <Route path="/admin/*" element={
            admin
              ? <AdminDashboard admin={admin} onLogout={handleAdminLogout} />
              : <Navigate to="/admin/login" />
          } />
          <Route path="/*" element={
            user
              ? <Dashboard user={user} onLogout={handleLogout} />
              : <Navigate to="/login" />
          } />
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  )
}

export default App